import { NotificationPriority, NotificationType } from './types'
import type { Notification } from './types'

/** Префикс id уведомлений, пришедших с сервера: по нему понимаем, что состояние надо синхронизировать. */
export const SERVER_ID_PREFIX = 'srv-'

export interface ServerNotification {
  id: number
  type: string
  title: string
  message: string | null
  is_read: boolean
  priority?: string | null
  action_url?: string | null
  action_text?: string | null
  created_at: string
  data?: Record<string, unknown> | null
}

export const isServerNotificationId = (id: string): boolean => id.startsWith(SERVER_ID_PREFIX)

export const serverNotificationId = (id: string): number => Number(id.slice(SERVER_ID_PREFIX.length))

function mapType(serverType: string): Notification['type'] {
  if (serverType.endsWith('.cancelled') || serverType.endsWith('.rejected')) {
    return NotificationType.WARNING
  }
  if (serverType.startsWith('system')) return NotificationType.SYSTEM
  return NotificationType.INFO
}

function mapPriority(priority: string | null | undefined): NotificationPriority {
  switch (priority) {
    case 'low':
      return NotificationPriority.LOW
    case 'high':
      return NotificationPriority.HIGH
    case 'urgent':
      return NotificationPriority.CRITICAL
    default:
      return NotificationPriority.NORMAL
  }
}

/** Запись из GET /api/notifications в модель центра уведомлений. */
export function mapServerNotification(raw: ServerNotification): Notification {
  const notification: Notification = {
    id: `${SERVER_ID_PREFIX}${raw.id}`,
    type: mapType(raw.type),
    title: raw.title,
    message: raw.message ?? '',
    read: raw.is_read,
    priority: mapPriority(raw.priority),
    createdAt: new Date(raw.created_at),
  }
  if (raw.action_url) notification.actionUrl = raw.action_url
  if (raw.action_text) notification.actionText = raw.action_text
  if (raw.data) notification.data = raw.data
  return notification
}
